import React from 'react';

import PropTypes from 'prop-types';

import FilledButton from 'components/application/buttons/FilledButton';
import TextButton from 'components/application/buttons/TextButton';
import ModalBox from 'components/application/ModalBox';

export default function ResetTableToDefaultConfirmationModal({
  isOpen,
  onClose,
  onResetTableToDefaultClick,
}) {
  return (
    <ModalBox
      customFooter={
        <div className='modalbox__footer-actions modalbox__footer-actions--right'>
          <TextButton
            className='tw-mr-3'
            color='blue'
            onClick={onClose}
            size='md'
          >
            Cancel
          </TextButton>
          <FilledButton color='red' onClick={onResetTableToDefaultClick}>
            Reset table to default
          </FilledButton>
        </div>
      }
      isOpen={isOpen}
      mode='flexible'
      onClose={onClose}
    >
      <div className='tw-p-6'>
        <h2 className='tw-m-0 tw-mb-6 tw-p-0 tw-text-xl tw-font-semibold tw-tracking-tight tw-text-grey-900'>
          Are you sure you want to reset table to default?
        </h2>
        <p className='tw-m-0 tw-p-0 tw-text-m tw-font-normal tw-text-grey-700'>
          This will reset column visibility, order, and size. Any sorting or
          filters applied will also be reset.
        </p>
      </div>
    </ModalBox>
  );
}

ResetTableToDefaultConfirmationModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onResetTableToDefaultClick: PropTypes.func.isRequired,
};
